import { render, staticRenderFns } from "./QuestionResult.vue?vue&type=template&id=25d86e86"
import script from "./QuestionResult.vue?vue&type=script&lang=js"
export * from "./QuestionResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports